import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'beedigitApi'),
  uk: createLocale(uk, 'beedigitApi'),
  pl: createLocale(pl, 'beedigitApi'),
  ru: createLocale(ru, 'beedigitApi'),
  es: createLocale(es, 'beedigitApi'),
  uz: createLocale(uz, 'beedigitApi'),
  hi: createLocale(hi, 'beedigitApi'),
};

export default locales;
